import {ISelection, Selection} from '@fluentui/react'

const orderSelection: ISelection = new Selection()
const completeOrderSelection: ISelection = new Selection()
const defaultSelection: ISelection = new Selection()

export {orderSelection ,defaultSelection,completeOrderSelection}